import { useMutation } from 'react-query';

import { toast } from '@/components/toast';
import { ToastMsg } from '@/components/toast/ToastMsg';
import { logger } from '@/services/logger';
import { bulkDownload, download, DownloadData } from '@/utils/utils';

export function useDownloadFileMutation(onCancel?: () => void) {
    let toastId: any;
    const controller = new AbortController();

    return useMutation(
        ({ dataurl, filename, extension }: Omit<DownloadData, 'controller'>) => download({ dataurl, filename, controller, extension }),
        {
            onMutate: () => {
                toastId = toast.loading({
                    title: 'Downloading file',
                    render: (
                        <ToastMsg
                            message={'Downloading...'}
                            buttonText={'Cancel'}
                            onButtonClick={() => {
                                controller.abort();
                                onCancel?.();
                            }}
                        />
                    ),
                });
            },
            onSuccess: () => {
                toast.dismiss(toastId);
            },
            onError: (error: any, originalRequest) => {
                toast.dismiss(toastId);
                if (error.name !== 'AbortError') {
                    logger.error('failed downloading file', { error, originalRequest });
                    if (originalRequest.dataurl) {
                        window.open(originalRequest.dataurl);
                    }
                }
            },
        }
    );
}

export function useBulkDownloadFileMutation(onCancel?: () => void, zipName?: string, enableIndexing?: boolean) {
    let toastId: any;
    const controller = new AbortController();

    return useMutation(
        (filesToDownload: Omit<DownloadData, 'controller'>[]) => bulkDownload(filesToDownload, controller, zipName, enableIndexing),
        {
            onMutate: () => {
                toastId = toast.loading({
                    title: 'Bulk downloading files',
                    render: (
                        <ToastMsg
                            message={'Downloading...'}
                            buttonText={'Cancel'}
                            onButtonClick={() => {
                                controller.abort();
                                onCancel?.();
                            }}
                        />
                    ),
                });
            },
            onSuccess: () => {
                toast.dismiss(toastId);
            },
            onError: (error: any, originalRequest) => {
                toast.dismiss(toastId);
                if (error.name !== 'AbortError') {
                    logger.error('failed downloading file', { error, originalRequest });
                }
            },
        }
    );
}
